import React, { useState, useEffect } from "react";
import Testimonial from "./testimonial";
import bbLogo from "../../../../img/bb-logo.png";
import Marquee from "react-marquee-slider";
import times from "lodash/times";
import { withSize } from "react-sizeme";
import salgtraktenThumbnail from "../../../../img/thumbnail_salgtrakten.png";
import bowiiThumbnail from "../../../../img/thumbnail_bowii.png";
import { nanoid } from "nanoid";
import "./style.scss";

const Index = () => {
  const [key, setKey] = useState(nanoid());

  useEffect(() => {
    setKey(nanoid());
  }, [setKey]);

  let scale = 1;

  const testimonials = [
    {
      id: 0,
      company: "B&B Marketing",
      name: "Erlend Bognøy",
      role: "Daglig leder",
      text: "Vet du hva som skjedde i går? 😃 Landet en 150 000,-/mnd kontrakt, med en kunde som jeg fant gjennom tjenesten! Har offisielt fått en sinnsykt god avkastning på Leadfind-investeringen min 😃 Hadde aldri fått den kunden uten Leadfind 📈",
      thumbnail: bbLogo,
      url: "https://bbmarketing.no",
    },
    {
      id: 1,
      company: "Salgtrakten",
      name: "Andreas Nygaard",
      role: "Daglig leder",
      text: "Jeg er veldig fornøyd med Leadfind og hvordan det har gitt virksomheten min flere kunder, kan ikke annet enn å anbefale! Kan ikke sammenlignes med offentlige oppslagstjenester, her har du alt du trenger på ett sted og mye mer 👌🏻",
      thumbnail: salgtraktenThumbnail,
      url: "https://www.salgtrakten.no/hjem",
    },
    {
      id: 2,
      company: "Bowii AS",
      name: "Emil Eriksson",
      role: "Daglig leder",
      text: "Leadfind har blitt til en viktig del av vårt salgsarbeid. Vi opplever høy relevanse på informasjon, og får møter med litt over 80% på første samtale. Tjenesten smaker helt enkelt mer enn den koster, og anbefales sterkt videre.",
      thumbnail: bowiiThumbnail,
      url: "https://bowii.no",
    },
  ];

  return (
    <section className="frontpage-testimonials-section">
      <div className="inner-frontpage-testimonials-container">
        <div className="content-container">
          <div className="introduction-container">
            <h1 className="section-title">Hva sier kundene våre?</h1>
            <p className="section-description">
              Vi har hjulpet våre brukere med å finne nye leads og kunder,
              samtidig som vi har generert flere millioner kroner ekstra i
              salgsinntekter, og dette er hva noen av dem sier.
            </p>
          </div>
          <div className="slider-container">
            <div className="marquee-container">
              <Marquee key={key} velocity={17.5} minScale={1}>
                {testimonials.map((detail) => (
                  <Testimonial scale={scale} details={detail} />
                ))}
              </Marquee>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
